import React, { useEffect, useState } from 'react';
import { FormController, getParamsForm, useOneFormContext } from 'src/feature-app';
import { OneElementTemplateFullScreen } from 'src/feature-app/Screen';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import { Text, Container, ContainerPadding, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { CarlineSelect, MultipleCTASelection, DetalleMotivo, MultipleOptionCTAs, SuggestModelo, LocateUserFullScreen } from 'src/components';
import { ConfirmacionNoRenovacion, ThankYouNoRenovacion, MapaNoRenovacion, FakeTriggerCTA } from '.';
import { NoRenovacionFormProps } from './NoRenovacionController';
import { formDataBuilder } from 'src/forms/format-fields';
import { dpsSend } from 'src/bff';
import { useInitializeNoRenovacionForm } from './use-initialize-no-renovacion-form';
import { addRemovedStep, getIndexInSteps, removeStep, resetStepsScreenIndex } from '../helpers/add-remove-steps';
import {
  CTAsSiNo,
  CTAsNuevoOcasión,
  CTAsMotivoRenovadorNoTengo,
  CTAsMotivoRenovadorYaTengo,
  CTAsMotivoRenovadorNoTengoExclusivo
} from 'src/feature-app/InputsValues/CTAsObjects';

const getModeloInteresTitle = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return (
      <>
        <Text bold>¿Qué modelo </Text>te llama más la{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          atención?
          <sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
        </span>
      </>
    );
  } else {
    return (
      <>
        <Text bold>¿Qué otra marca y modelo </Text>estás valorando principalmente?
      </>
    );
  }
};

const getModeloInteresFields = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return (
      <OneElementTemplateFullScreen
        element={
          <div style={{ marginBottom: '2px' }}>
            <CarlineSelect useCarline notALayer alphabetical />
          </div>
        }
      />
    );
  } else {
    return (
      <OneElementTemplateFullScreen
        allowOverflowingContent
        element={
          <div style={{ marginBottom: '2px', marginTop: '44px' }}>
            <SuggestModelo
              notALayer
              filterVW
              marginTop="0"
              fieldsName="modeloUno"
              required
              outputsSeparados
              nextOnClick
            />
          </div>
        }
      />
    );
  }
};

const getModeloInteresOutputs = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return ['modelo'];
  } else {
    return ['brand', 'model'];
  }
};
const getModeloInteresOutputsText = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return ['modelo'];
  } else {
    return ['brand', 'model'];
  }
};

const getDudasTitle = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return (
      <>
        ¿Hay algo que te esté{' '}
        <Text bold>
          haciendo dudar en la compra del{' '}
          <span style={{ whiteSpace: 'nowrap' }}>
            Volkswagen?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
          </span>
        </Text>
        <Container padding={{ top: ContainerPadding.dynamic0020 }}>
          <Text appearance={TokenTextAppearance.copy200} staticSize>
            Elige un máximo de 3 opciones
          </Text>
        </Container>
      </>
    );
  } else {
    return (
      <>
        <Text bold>¿Por qué motivos </Text>
        no estás valorando un{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          Volkswagen?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
        </span>
        <Container padding={{ top: ContainerPadding.dynamic0020 }}>
          <Text appearance={TokenTextAppearance.copy200} staticSize>
            Elige un máximo de 3 opciones
          </Text>
        </Container>
      </>
    );
  }
};
const getDudasAlternatTitle = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return (
      <>
        ¿Hay algo que te esté{' '}
        <Text bold>
          haciendo dudar en la compra del{' '}
          <span style={{ whiteSpace: 'nowrap' }}>
            Volkswagen?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
          </span>
        </Text>
      </>
    );
  } else {
    return (
      <>
        <Text bold>¿Por qué motivos </Text>
        no estás valorando un{' '}
        <span style={{ whiteSpace: 'nowrap' }}>
          Volkswagen?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
        </span>
      </>
    );
  }
};

const getDudasFields = (quieroVolkswagen: string) => {
  if (quieroVolkswagen === 'true') {
    return (
      <OneElementTemplateFullScreen
        element={
          <MultipleOptionCTAs
            ctaValues={CTAsMotivoRenovadorNoTengo}
            name="multipleChoice"
            maxSelected={3}
            minSelected={1}
            ignoreHandleClick={true}
            exclusiveCTA
            exclusiveCTAValues={CTAsMotivoRenovadorNoTengoExclusivo}
          />
        }
      />
    );
  } else {
    return (
      <OneElementTemplateFullScreen
        element={
          <MultipleOptionCTAs
            ctaValues={CTAsMotivoRenovadorYaTengo}
            name="multipleChoice"
            maxSelected={3}
            minSelected={1}
            ignoreHandleClick={true}
          />
        }
      />
    );
  }
};

export enum NoRenovacionSigueBuscando {
  Introduccion,
  QuieroVolkswagen,
  Modelo,
  TipoCoche,
  OtraMarca,
  Motivo,
  MasInformacion,
  // QuieroContacto,
  Mapa,
  Confirmacion,
}

export function NoRenovacionNoTengo({
  dpsData,
  idVehicle,
  idPerson,
  handleError,
  trackFormLoad,
  estado,
}: NoRenovacionFormProps) {
  const { initializeForm, handleNextStep } = useOneFormContext();
  const { formData, formInfo } = useSelector((state: OneFormState) => state);
  const { quieroVolkswagen, multipleChoice } = formData.fields;
  const { screenIndex } = formInfo;
  const dispatch = useDispatch();
  const [loadingPresubmit, setLoadingPresubmit] = useState(false);
  const store = useStore();

  useEffect(() => {
    const sendPresubmit = async () => {
      const result = await sendForm(true);

      if (!result) {
        handleError();
      }
      setLoadingPresubmit(false);
    };

    sendPresubmit();
  }, []);

  const updateModeloInteresStep = (quieroVolkswagen: string) => {
    const { steps: actualSteps } = store.getState().formInfo;
    const title = getModeloInteresTitle(quieroVolkswagen);
    const fields = getModeloInteresFields(quieroVolkswagen);
    const outputs = getModeloInteresOutputs(quieroVolkswagen);
    const outputsText = getModeloInteresOutputsText(quieroVolkswagen);

    let newSteps = [...steps];

    const modeloIndex = newSteps.findIndex((step: Steps) => step.name === 'Modelo');

    newSteps[modeloIndex].title = title;
    newSteps[modeloIndex].fields = fields;
    newSteps[modeloIndex].outputs = outputs;
    newSteps[modeloIndex].outputsText = outputsText;

    if (quieroVolkswagen === 'false') {
      newSteps = removeStep(newSteps, 'Mapa');
      dispatch({ type: 'UPDATE_FIELDS', payload: { quieroContacto: 'false' } });
    } else {
      const mapaIndex = getIndexInSteps(newSteps, 'Mapa');
      dispatch({ type: 'UPDATE_FIELDS', payload: { quieroContacto: 'true' } });

      if (mapaIndex === -1) {
        newSteps = addRemovedStep(steps, actualSteps, 'Mapa', screenIndex);
      }
    }

    newSteps = resetStepsScreenIndex(newSteps);

    dispatch({ type: 'UPDATE_STEPS', payload: newSteps });
    dispatch({ type: 'UPDATE_LAST_STEP', payload: newSteps[newSteps.length - 1] });
    dispatch({ type: 'SET_NUMBER_OF_SCREENS', payload: newSteps.length });
  };

  const handleStepsNoVolkswagen = (quieroVolkswagen: string) => {
    const { steps: actualSteps, screenIndex } = store.getState().formInfo;
    let newSteps = [...steps];

    if (quieroVolkswagen === 'true') {
      newSteps = [...steps];
    } else {
      newSteps = removeStep(newSteps, 'tipoCoche');
      newSteps = removeStep(newSteps, 'otraMarca');
      newSteps = removeStep(newSteps, 'Mapa');
    }

    newSteps = resetStepsScreenIndex(newSteps);

    dispatch({ type: 'UPDATE_STEPS', payload: newSteps });
    dispatch({ type: 'UPDATE_LAST_STEP', payload: newSteps[newSteps.length - 1] });
    dispatch({ type: 'SET_NUMBER_OF_SCREENS', payload: newSteps.length });
  };

  const steps: Steps[] = [
    {
      title: (
        <>
          <Text bold>Nos encantaría seguir siendo tu compañero de viaje. </Text>
          Cuéntanos qué te hace dudar para poder ayudarte.
        </>
      ),
      fields: <OneElementTemplateFullScreen allowOverflowingContent element={<FakeTriggerCTA />} />,
      screenIndex: NoRenovacionSigueBuscando.Introduccion,
      name: 'introduccion',
    },
    {
      title: (
        <>
          <Text bold>
            ¿Estás valorando un{' '}
            <span style={{ whiteSpace: 'nowrap' }}>
              Volkswagen?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
            </span>
          </Text>
        </>
      ),
      fields: (
        <OneElementTemplateFullScreen
          element={<MultipleCTASelection ctaValues={CTAsSiNo} name="quieroVolkswagen" ctaWidth="81" nextOnClick />}
        />
      ),
      screenIndex: NoRenovacionSigueBuscando.QuieroVolkswagen,
      name: 'quieroVolkswagen',
      outputs: ['quieroVolkswagen'],
      outputsText: ['quieroVolkswagen'],
      trueOrFalseQuestion: true,
    },
    {
      title: <></>, // Se actualiza en updateModeloInteresStep
      fields: <></>, // Se actualiza en updateModeloInteresStep
      screenIndex: NoRenovacionSigueBuscando.Modelo,
      name: 'Modelo',
      showOverflow: true,
    },
    {
      title: (
        <>
          <Text bold>¿Qué tipo de coche </Text>
          te{' '}
          <span style={{ whiteSpace: 'nowrap' }}>
            interesa?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
          </span>
        </>
      ),
      fields: (
        <OneElementTemplateFullScreen
          element={<MultipleCTASelection ctaValues={CTAsNuevoOcasión} name="tipoCoche" nextOnClick />}
        />
      ),
      screenIndex: NoRenovacionSigueBuscando.TipoCoche,
      name: 'tipoCoche',
      outputs: ['tipoCoche'],
      outputsText: ['tipoCoche'],
    },
    {
      title: (
        <>
          ¿Estás valorando algún{' '}
          <Text bold>
            modelo de otra{' '}
            <span style={{ whiteSpace: 'nowrap' }}>
              marca?<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
            </span>
          </Text>
        </>
      ),
      fields: (
        <OneElementTemplateFullScreen
          allowOverflowingContent
          element={
            <SuggestModelo
              notALayer={true}
              fieldsName="otraMarca"
              required={true}
              outputsSeparados
              filterVW
              alternatCTA
              nextOnClick
            />
          }
        />
      ),
      screenIndex: NoRenovacionSigueBuscando.OtraMarca,
      name: 'otraMarca',
      outputs: ['brand', 'model'],
      outputsText: ['brand', 'model'],
      showOverflow: true,
    },
    {
      title: getDudasTitle(quieroVolkswagen),
      alternateTitle: getDudasAlternatTitle(quieroVolkswagen),
      fields: getDudasFields(quieroVolkswagen),
      screenIndex: NoRenovacionSigueBuscando.Motivo,
      name: 'Dudas',
      outputs: ['multipleChoice'],
      outputsText: ['multipleChoice'],
    },
    {
      title: (
        <>
          <Text bold>¿Qué otros motivos </Text>te hacen dudar?
        </>
      ),
      fields: (
        <OneElementTemplateFullScreen element={<DetalleMotivo CTALabel="Eso es todo" label="Escríbelos aquí" />} />
      ),
      screenIndex: NoRenovacionSigueBuscando.MasInformacion,
      name: 'MasInformacion',
      outputs: ['masInformacion'],
      outputsText: ['masInformacion'],
    },
    {
      screenIndex: NoRenovacionSigueBuscando.Mapa,
      name: 'Mapa',
      multiStep: true,
      component: <MapaNoRenovacion />,
    },
    {
      fields: <ConfirmacionNoRenovacion idPerson={idPerson} />,
      screenIndex: NoRenovacionSigueBuscando.Confirmacion,
      name: 'Confirmacion',
      outputs: ['confirmacion'],
      outputsText: ['confirmacion'],
    },
  ];

  const NuevoFormData: Partial<FormDataGroup> = {
    fields: {
      formName: 'no_renovacion-no_tengo',
      formType: 'otherform',
      pageCategory: 'Encuesta',
    }, // Analítica
  };
  //mostrar u ocultar pantalla mas información según los ctas de dudas seleccionados

  const handleMasInformacion = (multipleChoice: string[]) => {
    const { steps: actualSteps } = store.getState().formInfo;

    let newSteps = [...actualSteps];

    if (multipleChoice.includes('otros motivos')) {
      const stepIndex = getIndexInSteps(newSteps, 'MasInformacion');

      if (stepIndex === -1) {
        newSteps = addRemovedStep(steps, actualSteps, 'MasInformacion', screenIndex);
        setTimeout(() => {
          handleNextStep();
        }, 0);
      }
    } else {
      newSteps = removeStep(newSteps, 'MasInformacion');
    }

    const newStepsWithIndex = resetStepsScreenIndex(newSteps);

    dispatch({ type: 'UPDATE_STEPS', payload: newStepsWithIndex });
    dispatch({ type: 'UPDATE_LAST_STEP', payload: newStepsWithIndex[newStepsWithIndex.length - 1] });
    dispatch({ type: 'SET_NUMBER_OF_SCREENS', payload: newStepsWithIndex.length });
  };


  const generateData = (data?: Partial<FormDataGroup>) => {
    const { formData, dealersInfo }: OneFormState = store.getState();
    const { fields, headers } = formData;
    const { selectedInstallation } = dealersInfo;

    let TXT_V_KVPS_code__c, FRML_TXT_codVentaProvincia__c, TXT_V_Installation_Data_Name__c, TXT_V_Installation_Code__c;
    if (selectedInstallation) {
      TXT_V_KVPS_code__c = selectedInstallation.TXT_V_KVPS_code__c;
      FRML_TXT_codVentaProvincia__c = selectedInstallation.FRML_TXT_codVentaProvincia__c;
      TXT_V_Installation_Data_Name__c = selectedInstallation.TXT_V_Installation_Data_Name__c;
      TXT_V_Installation_Code__c = selectedInstallation.TXT_V_Installation_Code__c;
    }

    const { tc, today, url, device } = getParamsForm();
    return {
      'headers[TC]': tc,
      'headers[PINCODE]': dpsData.pincode.pincodeResponse.params.pincode,
      'headers[FECHA_INSERTION_DATE]': today,
      'headers[DESC_FORMOBJECTIVE]': fields.quieroContacto === 'true' ? 'Más Información' : 'Encuesta',
      'headers[DESC_TOKEN]': 'VW_DDB_FORM_NORENUEVA',
      'headers[DESC_FORM_DETAIL]': 'NoRenovación Grabación',
      'headers[DESC_DEVICETYPE]': device,
      'headers[COD_FORM_ID]': fields.formName ? `vw-oneform-${fields.formName}` : `vw-oneform-${data.fields.formName}`,
      'headers[DESC_URLORIGIN]': url,
      'headers[DESC_VN_VO]': fields.tipoCoche === 'nuevo' ? 'VN' : 'VO',
      'headers[DESC_ID_CLIMAPRO]': idPerson.ID_Person_DIM_IMP__c,
      'headers[DESC_ID_VEHICLE_CLIMAPRO]': idVehicle.IDClimapro__c,
      'headers[DESC_BRAND]': 'VW',
      'headers[DESC_GDPR_ADAPTED]': 'true',
      'headers[DESC_ID_CAMPAIGN]': '7011n000000JvhCAAS',
      'headers[DESC_CAMPAIGNBLOCK]': 'B19 - Renovadores',
      'headers[DETALLE_TIPO_PETICION_SIM]': 'Encuesta Renovación',

      'fields[DESC_NAME]': idPerson.FirstName,
      'fields[DESC_SURNAME_1]': idPerson.LastName,
      'fields[DESC_SURNAME_2]': idPerson.TXT_2_Surname__c,
      'fields[NUM_CELLPHONE]': idPerson.NUM_Phone_mobile__c,
      'fields[DESC_EMAIL_ADDRESS]': idPerson.TXT_Email__c,

      'fields[DESC_AUXFIELD1]': 'No tengo',
      'fields[DESC_FORM_VERSION]': fields.formName
        ? `vw-oneform-${fields.formName}-${process.env.VERSION}`
        : `vw-oneform-${data.fields.formName}-${process.env.VERSION}`,
      'fields[DESC_AUXFIELD9]': fields.quieroVolkswagen,
      'fields[COD_INTEREST_CARLINE]': fields.quieroVolkswagen === 'true' ? fields.carlineCode : null,
      'fields[DESC_INTEREST_CARLINE]': fields.quieroVolkswagen === 'true' ? fields.modelo : null,
      'fields[DESC_AUXFIELD10]': fields.quieroVolkswagen === 'true' ? fields.multipleChoice : null,
      'fields[DESC_AUXFIELD11]': fields.quieroVolkswagen === 'true' ? fields.masInformacion : null,

      'fields[DESC_DEALER]': fields.quieroContacto === 'true' ? TXT_V_Installation_Data_Name__c : null,
      'fields[DESC_DEALER_CODE]': fields.quieroContacto === 'true' ? TXT_V_Installation_Code__c : null,
      'fields[DESC_DEALER_CODE_KVPS]': fields.quieroContacto === 'true' ? TXT_V_KVPS_code__c : null,
      'fields[COD_DEALER_PROVINCE]': fields.quieroContacto === 'true' ? FRML_TXT_codVentaProvincia__c : null,
      'fields[DESC_DEALER_PROVINCE]': fields.quieroContacto === 'true' ? fields.provinceName : null,
      'fields[DESC_DEALER_SHARE]': fields.compartir,

      'fields[DESC_AUXFIELD14]': fields.brand === 'false' ? null : fields.brand,
      'fields[DESC_AUXFIELD15]': fields.model === 'false' ? null : fields.model,
      'fields[DESC_AUXFIELD12]': fields.quieroVolkswagen === 'true' ? null : fields.multipleChoice,
      'fields[DESC_AUXFIELD13]': fields.quieroVolkswagen === 'true' ? null : fields.masInformacion,
      'fields[M_OBSERVATION_BRAND]': fields.masInformacion
        ? `Motivos de duda indicados por el cliente en la encuesta: ${fields.multipleChoice}. ${fields.masInformacion}`
        : `Motivos de duda indicados por el cliente en la encuesta: ${fields.multipleChoice}.`,
      'fields[DESC_LOPD]': 'PERMITE', // SOLO EN SUBMIT
      'fields[DESC_TRANF_DATA_THIRD]': 'NO INFORMADO', // SOLO EN SUBMIT
      'fields[DESC_LSSI]': fields.lssi ? fields.lssi : 'NO INFORMADO',
      'fields[DESC_LOPD_GDPR_PERFILADO]': fields.tmk ? fields.tmk : 'NO INFORMADO',
      'fields[DESC_DATA_ENRICHMENT]': 'NO INFORMADO',

      'flags[FLAG_ISLEAD]': fields.quieroVolkswagen === 'false' ? 'false' : fields.quieroContacto,
      'flags[FLAG_ISPROSPECT]':
        fields.quieroVolkswagen === 'true' && fields.quieroContacto === 'false' ? 'true' : 'false',
      'flags[FLAG_GENERATELEM]': fields.quieroVolkswagen === 'false' ? 'false' : fields.quieroContacto,
    };
  };

  const generateSubmitData = () => generateData();

  /**
   * Generamos la misma data que para el submit y eliminamos todos los campos que no son necesarios para el presubmit.
   */
  const generatePresubmitData = () => {
    const data = generateData(NuevoFormData);

    delete data['headers[PINCODE]'];
    delete data['headers[DESC_VN_VO]'];
    delete data['headers[DETALLE_TIPO_PETICION_SIM]'];

    delete data['fields[DESC_TRANF_DATA_THIRD]'];
    delete data['fields[DESC_AUXFIELD9]'];
    delete data['fields[COD_INTEREST_CARLINE]'];
    delete data['fields[DESC_INTEREST_CARLINE]'];
    delete data['fields[DESC_AUXFIELD10]'];
    delete data['fields[DESC_AUXFIELD11]'];
    delete data['fields[DESC_AUXFIELD12]'];
    delete data['fields[DESC_AUXFIELD13]'];
    delete data['fields[DESC_DEALER]'];
    delete data['fields[DESC_DEALER_CODE]'];
    delete data['fields[DESC_DEALER_CODE_KVPS]'];
    delete data['fields[COD_DEALER_PROVINCE]'];
    delete data['fields[DESC_DEALER_PROVINCE]'];
    delete data['fields[DESC_DEALER_SHARE]'];
    delete data['fields[DESC_AUXFIELD14]'];
    delete data['fields[DESC_AUXFIELD15]'];
    delete data['fields[M_OBSERVATION_BRAND]'];

    delete data['flags[FLAG_ISLEAD]'];
    delete data['flags[FLAG_ISPROSPECT]'];
    delete data['flags[FLAG_GENERATELEM]'];
    delete data['fields[DESC_LOPD]'];
    delete data['fields[DESC_LSSI]'];
    delete data['fields[DESC_LOPD_GDPR_PERFILADO]'];
    delete data['fields[DESC_DATA_ENRICHMENT]'];

    data['fields[DESC_AUXFIELD1]'] = 'No tengo';
    data['headers[DESC_FORM_DETAIL]'] = 'NoRenovación Pregrabación';
    data['headers[DESC_TOKEN]'] = 'VW_DDB_FORM_NORENUEVA_PRE';

    return data;
  };

  const sendForm = async (isPresubmit?: boolean): Promise<boolean> => {
    return new Promise<any>(async (resolve, reject) => {
      const data = isPresubmit ? generatePresubmitData() : generateSubmitData();
      const dataStringified = JSON.stringify(data);
      const dataParsed = JSON.parse(dataStringified);

      const formData = formDataBuilder(dataParsed);

      const response = await dpsSend(formData);

      if (response.data?.content?.code === '200') {
        dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  const { firstStep, lastStep, loading } = useInitializeNoRenovacionForm(steps);

  useEffect(() => {
    const NuevoFormInfo: Partial<FormInfo> = {
      formStarted: true,
      sendFormCallback: sendForm,
      fullScreen: firstStep.fullScreen ? true : false,
      lastStep,
      numberOfScreens: steps.length,
      screenIndex: firstStep.screenIndex,
      formTheme: 'main',
      notALayer: true,
      formType: 'inPage',
      step: firstStep,
      steps,
      stepsHistory: [0],
      thankYouComponent: <ThankYouNoRenovacion />,
    };

    if (!loading) {
      initializeForm(NuevoFormInfo, NuevoFormData, true);
      trackFormLoad();
    }
  }, [loading]);

  //activación de lógica para la gestion de steps

  useEffect(() => {
    if (quieroVolkswagen) {
      updateModeloInteresStep(quieroVolkswagen);
      handleStepsNoVolkswagen(quieroVolkswagen);
    }

  }, [quieroVolkswagen]);

  useEffect(() => {
    if (multipleChoice) {
      handleMasInformacion(multipleChoice);
    }
  }, [multipleChoice]);

  return loading || loadingPresubmit || !steps ? null : <FormController steps={steps} screenType="full-screen" />;
}
